export default __webpack_public_path__ + "static/media/reactBW.3fe9c881.webp";